import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FootballState from "../state/football-state";
import { playerReducer } from "../../../storage/reducers";
import { isArray } from "../../../services/common/object-util";

export default class Safety extends Fragment {
    // Argless like every factory/revival construction path; tackledBy and
    // recoveredBy arrive via Object.assign when the operator answers.
    constructor() {
        super();
        this.requiredData = [
            {
                name: "tackledBy",
                type: FragmentDataType.Players,
                maxPlayers: 2,
                appliesToOpponent: () => true,
                displayName: "Tackled by",
                title: (team) => `Tackled By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player
                     from ${team.teamName} or enter the roster number`,
                isEditable: true,
                optional: true,
                // Skipping the player selector stores [] (the UI's skip
                // sentinel); undefined means not yet answered. Off the
                // fumble path the input never applies at all.
                isSkipped: (play) =>
                    !this.followsFumble(play) ||
                    (this.tackledBy && this.tackledBy.length === 0)
            },
            {
                name: "recoveredBy",
                type: FragmentDataType.Player,
                appliesToOpponent: () => false,
                displayName: "Recovered By",
                title: (team) => `Recovered By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player
                     from ${team.teamName} or enter the roster number`,
                isEditable: true,
                optional: true
            }
        ];
    }

    /**
     * Attribution inputs exist only on a fumble-preceded safety (flag
     * football's dead-ball rule); every other safety collects its players
     * on the preceding tackle/sack/recovery fragment. Derived from the play
     * history at call time - nothing is stamped on the fragment - so a play
     * whose branch is abandoned (goBack) self-corrects. Without a play
     * (e.g. transition previews) this reads false, which is the pre-feature
     * behavior: no inputs, transition auto-ends.
     */
    followsFumble(play) {
        return (
            play?.getHistory()[this.associatedHistoryIndex - 1]?.name ===
            FootballState.Fumble
        );
    }

    excludeRequiredData(rd, gameConfig, play) {
        return !this.followsFumble(play);
    }

    getPlayers() {
        const players = isArray(this.tackledBy) ? [...this.tackledBy] : [];
        if (this.recoveredBy?.id) {
            players.push(this.recoveredBy);
        }
        return players;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            tackledBy: isArray(this.tackledBy)
                ? this.tackledBy.map((p) => playerReducer(p))
                : this.tackledBy,
            recoveredBy: playerReducer(this.recoveredBy)
        };
    }
}
